import { PocList } from 'commons/components/components-wrapper/poc-list.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { SettingsSideBarTitle } from '../settings.style';
import { useNavigate } from 'react-router-dom';
import { SettingsModulePathValue } from 'core/routes/routes';

export interface SettingsSideBarItemMenu {
    title: string;
    url: SettingsModulePathValue;
}
export interface SettingsSideBarSection {
    title: string;
    items: SettingsSideBarItemMenu[];
}

export interface SideMenuListProps {
    items: SettingsSideBarSection[];
}

export const SideMenuList: React.FC<SideMenuListProps> = ({ items }) => {
    const navigate = useNavigate();

    return (
        <>
            {items.map((menu) => (
                <PocList key={menu.title} noBorder selected={[location.pathname]}>
                    <SettingsSideBarTitle>{menu.title}</SettingsSideBarTitle>
                    {menu.items.map((item, i) => (
                        <PocListItem
                            key={item.title}
                            noBorder={i !== menu.items.length - 1}
                            value={item.url}
                            onClick={() => {
                                navigate(item.url);
                            }}
                        >
                            {item.title}
                        </PocListItem>
                    ))}
                </PocList>
            ))}
        </>
    );
};
